import { useAuth } from '@clerk/clerk-react'

export function useIsAdmin() {
  const { sessionClaims } = useAuth()
  
  return sessionClaims?.app_role === 'admin'
}